import {
  FAIL_GET_UBER_EATS_GAME,
  REQUEST_GET_UBER_EATS_GAME,
  SUCCESS_GET_UBER_EATS_GAME,
} from '../../../actions/entities/uberEats';
import {createReducer} from '../../utilities';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  return {
    ...state,
    data: action.list,
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_GET_UBER_EATS_GAME]: requestFetch,
  [SUCCESS_GET_UBER_EATS_GAME]: successFetch,
  [FAIL_GET_UBER_EATS_GAME]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/uberEats/game.js